module.exports = __webpack_public_path__ + "static/media/dg_2.17a94c7e.png";